import { useEffect, useState } from "react";
import { Modal, Button, Select } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { cloneDeep } from "lodash";

import membersService from "@services/members.service";
import memberDetailsService from "@services/memberDetails.service";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import "./CurrentCM.scss";

import { CanEdit } from "@components/accessLevel";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";

const CurrentCM = () => {

  const memberData = useMemberDetailsStore((state) => state.memberData);
  const setMemberData = useMemberDetailsStore((state) => state.setMemberData);
  const currentSelectedCM = memberData?.attribCareManagerName && memberData?.attribCareManagerAssignmentStatus === "N" ? memberData?.attribCareManagerName : memberData?.currentCareManagerName;

  const [editMode, setEditMode] = useState<any>(false);
  const [careManagersList, setCareManagersList] = useState<any>([]);
  const [currentCmModalVisibility, setCurrentCmModalVisibility] = useState<any>(false);
  const [selectedCM, setSelectedCM] = useState<any>({
    label: memberData?.attribCareManagerName ? memberData?.attribCareManagerName : memberData?.currentCareManagerName,
    value: memberData?.attribCareManagerId ? memberData?.attribCareManagerId : memberData?.currentCareManagerId,
  });
  const [showLoader, setShowLoader] = useState<any>(false);

  useEffect(() => {
    console.log("CurrentCM.useEffect");
    memberDetailsService.fetchAttributeDropdown("CareManagerLst").subscribe({
      next: (response: any) => {
        setCareManagersList(response.data.data.data);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }, []);

  const updateAttribute = () => {
    console.log("CurrentCM.updateAttribute");
    const cMember = membersService?.getCurrentMember;
    setShowLoader(true);
    if (cMember && cMember?.patient_id) {
      const patient_id = parseInt(cMember?.patient_id);
      const payLoad = {
        attrib_name: "update_current_cm",
        currentAssignedCM: memberData?.currentCareManagerId,
        updatedCM: selectedCM?.value,
        patient_id: patient_id,
      };
      memberDetailsService.updateSelectedAttribute(payLoad).subscribe({
        next: (response: any) => {
          let temp_memDetail = cloneDeep(memberData);
          temp_memDetail = {
            ...temp_memDetail,
            attribCareManagerAssignmentStatus: selectedCM?.label === temp_memDetail?.memberDetails?.currentCareManagerName ? "Y" : "N",
            attribCareManagerId: selectedCM?.value,
            attribCareManagerName: selectedCM?.label,
          };
          setMemberData(temp_memDetail);
          setCurrentCmModalVisibility(false);
          setShowLoader(false);
        },
        error: (error) => {
          setShowLoader(false);
          console.log(error);
          setCurrentCmModalVisibility(false);
        },
      });
    }
  };

  const getGetCMFilteredOptionList = () => {
    return careManagersList?.filter((item: any) => item?.label !== currentSelectedCM);
  };

  return (
    <>
      {editMode ? (
        <Select
          autoFocus={true}
          onBlur={() => setEditMode(false)}
          showSearch
          placeholder={"Current CM"}
          onChange={(value, option) => {
            setSelectedCM(option);
            setCurrentCmModalVisibility(true);
          }}
          options={getGetCMFilteredOptionList()}
          onSearch={() => {}}
          filterOption={(input, option: any) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
          listHeight={100}
          listItemHeight={100}
          value={currentSelectedCM}
          size={"large"}
          className={"w-97per"}
        />
      ) : (
        <>
          <div className="member-detail-current-cm-read-mode">
            <span className="member-detail-current-cm-read-mode__name member-value">{currentSelectedCM}</span>
            {/* Commenting this functionality as we will be editing the primary user from Care Management */}
            {/* <CanEdit>
            <span className="member-detail-current-cm-read-mode__edit-icon color-for--generic_options" onClick={() => setEditMode(true)}>
              <EditOutlined />
            </span>
            </CanEdit> */}
          </div>
          <div className="member-detail-current-cm-read-mode__assignment-status">
            {memberData?.attribCareManagerAssignmentStatus === "N" ? "Pending reassignment, will be updated in 24 hours." : null}
          </div>
        </>
      )}

      <Modal open={currentCmModalVisibility} footer={null}>
        <div className="currentCmChangeModal">
          <div className="currentCmChangeModal__header">{`Do you want to update ${selectedCM.label} as care manager for ${membersService?.getCurrentMember?.patient_name} ?`}</div>
          <div className="currentCmChangeModal__body">CM update will reflect in 24 hours</div>
          <div className="currentCmChangeModal__footer">
            <div className="currentCmChangeModal__footer__cancel">
              <Button
                onClick={() => {
                  setCurrentCmModalVisibility(false);
                  setSelectedCM({
                    label: memberData?.attribCareManagerName ? memberData?.attribCareManagerName : memberData?.currentCareManagerName,
                    value: memberData?.attribCareManagerId ? memberData?.attribCareManagerId : memberData?.currentCareManagerId,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
            <div className="currentCmChangeModal__footer__ok">
              <Button type="primary" onClick={() => updateAttribute()} loading={showLoader}>{`Yes, Update CM`}</Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CurrentCM;
